<template>
  <div class="p-5 h-screen lg:h-[810px] overflow-y-scroll">
    <iframe
        id="widgetFrame"
        style="min-width: 100%;"
        scrolling="no"
        frameborder="0"
        width="100%"
        onload="iFrameResize({ heightCalculationMethod: 'max', checkOrigin: false }, '#widgetFrame')"
        :src="'https://social-ratings.plexytrade.com/widgets/ratings?widgetKey=highest-return-30-days&theme=light&lang=' + Language"
        class=""
    />
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
}
</script>

<style>
</style>
